import { combineReducers, configureStore } from '@reduxjs/toolkit'
import generalReducer from './reducers/generalReducer'
import chatReducer from './reducers/chatReducer'
import storage from 'redux-persist/lib/storage'
import { persistReducer } from 'redux-persist'
import { persistStore } from 'redux-persist'

const persistConfig = {
    key: 'root',
    storage,
}

const rootReducer = combineReducers({
    general: generalReducer,
    chat: chatReducer,
})

const persistedReducer = persistReducer(persistConfig, rootReducer)

const store = configureStore({
    reducer: persistedReducer,
})

export default store

export const persistor = persistStore(store)
